<div class="row">
    <div class="container-fluid pl-0 pr-0">
        <div class="row">
            <div class="col-xl-12">
                <div class="card card-header-actions mx-auto">
                    <div class="card-header">
                        Pay Web Component
                    </div>
                    <div class="card-body">
                        <style>
                            .txn-overlay {
                                position: fixed;
                                inset: 0;
                                background: rgba(0,0,0,0.45);
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                z-index: 1050;
                                padding: 1rem;
                            }
                            .txn-card {
                                width: 100%;
                                max-width: 680px;
                                background: #fff;
                                border-radius: 8px;
                                box-shadow: 0 8px 24px rgba(16,24,40,0.2);
                                overflow: hidden;
                            }
                            .txn-header {
                                display: flex;
                                align-items: center;
                                justify-content: space-between;
                                padding: 1rem 1.25rem;
                                border-bottom: 1px solid #eee;
                            }
                            .txn-title {
                                display: flex;
                                gap: 0.75rem;
                                align-items: center;
                                font-weight: 600;
                                font-size: 1.05rem;
                            }
                            .txn-body {
                                padding: 1.25rem;
                            }
                            .txn-grid {
                                display: grid;
                                grid-template-columns: 1fr 1fr;
                                gap: 0.75rem 1.5rem;
                            }
                            .txn-row {
                                background: #fafafa;
                                padding: 0.7rem;
                                border-radius: 6px;
                            }
                            .txn-key { color: #666; font-size: 0.85rem; }
                            .txn-val { font-weight: 600; font-size: 0.95rem; }
                            .txn-amount { font-size: 1.25rem; color: #0b6b3a; font-weight: 700; }
                            .txn-footer {
                                display:flex; justify-content: flex-end; gap: 0.5rem; padding: 1rem 1.25rem; border-top:1px solid #eee;
                            }
                            @media (max-width:520px){ .txn-grid{ grid-template-columns: 1fr; } }
                        </style>

                        <div class="txn-overlay" role="dialog" aria-modal="true" *ngIf="showTransactionPopup">
                            <div class="txn-card">
                                <div class="txn-header">
                                    <div class="txn-title">
                                        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z" fill="#E6F4EA"/>
                                            <path d="M10 13l2 2 5-5" stroke="#06A84C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                        Transaction Details
                                    </div>
                                    <div>
                                        <span class="badge badge-success" style="font-weight:600;">{{payGateData?.status}}</span>
                                    </div>
                                </div>

                                <div class="txn-body">
                                    <div class="txn-grid">
                                        <div class="txn-row">
                                            <div class="txn-key">Transaction ID</div>
                                            <div class="txn-val">{{payGateData?.transaction_id}}</div>
                                        </div>

                                        <div class="txn-row">
                                            <div class="txn-key">Reference No.</div>
                                            <div class="txn-val">{{payGateData?.reference_no}}</div>
                                        </div>

                                        <div class="txn-row">
                                            <div class="txn-key">Payment Request ID</div>
                                            <div class="txn-val">{{payGateData?.pay_request_id}}</div>
                                        </div>

                                        <div class="txn-row">
                                            <div class="txn-key">Transaction Status</div>
                                            <div class="txn-val">{{payGateData?.transaction_status}}</div>
                                        </div>

                                        <div class="txn-row">
                                            <div class="txn-key">Transaction Date</div>
                                            <div class="txn-val">{{payGateData?.transaction_date}}</div>
                                        </div>

                                        <div class="txn-row">
                                            <div class="txn-key">Status</div>
                                            <div class="txn-val">{{payGateData?.status}}</div>
                                        </div>
                                    </div>

                                    <div style="margin-top:1rem; display:flex; align-items:center; justify-content:space-between; gap:1rem;">
                                        <div>
                                            <div class="txn-key">Amount</div>
                                            <div class="txn-amount">₹ {{payGateData?.amount}}</div>
                                        </div>
                                        <div style="text-align:right; color:#888; font-size:0.9rem">Message: {{payGateData?.message || 'Status Retrieved'}}</div>
                                    </div>
                                </div>

                                <div class="txn-footer">
                                    <button type="button" class="btn btn-light" (click)="closeModal()">Close</button>
                                    <button type="button" class="btn btn-primary">Print Receipt</button>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>